import React from "react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  const containerStyle = {
    textAlign: "center",
    padding: "clamp(10px, 5vw, 20px)",
    maxWidth: "600px",
    margin: "0 auto",
  };

  const buttonStyle = {
    padding: "clamp(8px, 2vw, 10px) clamp(15px, 3vw, 20px)",
    fontSize: "clamp(14px, 2.5vw, 16px)",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    cursor: "pointer",
    marginTop: "10px",
  };

  return (
    <div style={containerStyle}>
      <h1>Thank You!</h1>
      <p>Your inquiry has been submitted successfully.</p>
      <p>We’ll get back to you soon.</p>
      <Link to="/">
        <button style={buttonStyle}>Back to Home</button>
      </Link>
    </div>
  );
};

export default ThankYou;